import { MasterHelper } from '../../utilities';

export class SelfAssessmentT3FilterModel {
  fromDate?: Date | null;
  toDate: Date;
  searchQuery: string[];
  rulebook: string[];
  part: string[];
  owner: string[];
  regulatoryRuleFullRequirement: string[];
  assessmentStatus: string[];
  complianceStatus: string[];
  reviewDate?: Date | null;
  assessmentDate?: Date | null;
  lbgImpact: boolean | null = false;
  rfbImpact: boolean | null = false;
  lbcmImpact: boolean | null = false;
  nextAssessmentDue?: Date | null;
  sortKey: string;
  isDesc: boolean = false;
  jurisdictionId: number = 0;
  ruleId: string[];
  rulebookRuleId: string [];
  assessor:string [];

  constructor() {
    this.toDate = MasterHelper.getDateStr(0);
    this.searchQuery = [];
    this.rulebook = [];
    this.part = [];
    this.owner = [];
    this.regulatoryRuleFullRequirement = [];
    this.assessmentStatus = [];
    this.complianceStatus = [];
    this.sortKey = 'Id';
    this.ruleId =[];
    this.rulebookRuleId =[];
    this.assessor= [];
  }
}

export class rightsManagementSAT3Dto {
  ActionClosed: boolean;
  ActionClosure: boolean;
  ActionDetails: boolean;
  ActionDueDate: boolean;
  ActionOwner: boolean;
  ActionType: boolean;
  ApproachDetails: boolean;
  ApproachImplementationComments: boolean;
  ApprovalStatus: boolean;
  ApproverComments: boolean;
  ApproverDate: boolean;
  Approvers: boolean;
  ConditionalApproval: boolean;
  ConfirmApproval: boolean;
  EstimatedImpactLBCM: boolean;
  EstimatedImpactLBG: boolean;
  EstimatedImpactRFB: boolean;
  ImplementationComments: boolean;
  ImplementationDate: boolean;
  ImplementationStatus: boolean;
  InterpretationDetails: boolean;
  JudgementDetails: boolean;
  JudgementImplementationComments: boolean;
  LBCMMateriality: boolean;
  LBGMateriality: boolean;
  NatureOfReview: boolean;
  NextApprovalDue: boolean;
  ReadyForApproval: boolean;
  ReadyForReview: boolean;
  ReferenceNumber: boolean;
  ReviewDate: boolean;
  ReviewerComments: boolean;
  ReviewerName: boolean;
  ReviewOutcome: boolean;
  ReviewStatus: boolean;
  RFBMateriality: boolean;
  SubmitterName: boolean;
  Title: boolean;
  Topic: boolean;
  SaveAssessmentData: boolean;
  SaveReviewData: boolean;
  SaveApprovalsData: boolean;
  SaveCondApprovalsData: boolean;
  UplEvdAssessment: boolean;
  UplEvdReview: boolean;
  UplEvdApprove: boolean;
  UplEvdAction: boolean;
  AssessorName: boolean;
  AssessmentCategory: boolean;
  AssessmentStatus: boolean;
  AssessmentDate: boolean;
  NextAssessmentDue: boolean;
  AssessorTeam: boolean;
  ImpactedBusinessArea: boolean;
  LBGImpact: boolean;
  RFBImpact: boolean;
  LBCMImpact: boolean;
  ComplianceStatus: boolean;
  ActionRequired: boolean;
  AssessmentFindings: boolean;
  UplEvdOvrAllAsmnt: boolean;
  SaveOvrAllAsmnt: boolean;
  UplEvdOvrAllReview: boolean;
  SaveOvrAllReview: boolean;
  SaveOvrAllAction: boolean;
  ActionrRequiredReview: boolean;

  constructor(isAllowed: boolean) {
    // Initialize properties with default values or values from the provided object
    this.ActionClosed = isAllowed;
    this.ActionClosure = isAllowed;
    this.ActionDetails = isAllowed;
    this.ActionDueDate = isAllowed;
    this.ActionOwner = isAllowed;
    this.ActionType = isAllowed;
    this.ApproachDetails = isAllowed;
    this.ApproachImplementationComments = isAllowed;
    this.ApprovalStatus = isAllowed;
    this.ApproverComments = isAllowed;
    this.ApproverDate = isAllowed;
    this.Approvers = isAllowed;
    this.ConditionalApproval = isAllowed;
    this.ConfirmApproval = isAllowed;
    this.EstimatedImpactLBCM = isAllowed;
    this.EstimatedImpactLBG = isAllowed;
    this.EstimatedImpactRFB = isAllowed;
    this.ImplementationComments = isAllowed;
    this.ImplementationDate = isAllowed;
    this.ImplementationStatus = isAllowed;
    this.InterpretationDetails = isAllowed;
    this.JudgementDetails = isAllowed;
    this.JudgementImplementationComments = isAllowed;
    this.LBCMMateriality = isAllowed;
    this.LBGMateriality = isAllowed;
    this.NatureOfReview = isAllowed;
    this.NextApprovalDue = isAllowed;
    this.ReadyForApproval = isAllowed;
    this.ReadyForReview = isAllowed;
    this.ReferenceNumber = isAllowed;
    this.ReviewDate = isAllowed;
    this.ReviewerComments = isAllowed;
    this.ReviewerName = isAllowed;
    this.ReviewOutcome = isAllowed;
    this.ReviewStatus = isAllowed;
    this.RFBMateriality = isAllowed;
    this.SubmitterName = isAllowed;
    this.Title = isAllowed;
    this.Topic = isAllowed;
    this.SaveAssessmentData = isAllowed;
    this.SaveReviewData = isAllowed;
    this.SaveApprovalsData = isAllowed;
    this.SaveCondApprovalsData = isAllowed;
    this.UplEvdAssessment = isAllowed;
    this.UplEvdReview = isAllowed;
    this.UplEvdApprove = isAllowed;
    this.UplEvdAction = isAllowed;
    this.AssessorName = isAllowed;
    this.AssessmentCategory = isAllowed;
    this.AssessmentStatus = isAllowed;
    this.AssessmentDate = isAllowed;
    this.NextAssessmentDue = isAllowed;
    this.AssessorTeam = isAllowed;
    this.ImpactedBusinessArea = isAllowed;
    this.LBGImpact = isAllowed;
    this.RFBImpact = isAllowed;
    this.LBCMImpact = isAllowed;
    this.ComplianceStatus = isAllowed;
    this.ActionRequired = isAllowed;
    this.AssessmentFindings = isAllowed;
    this.UplEvdOvrAllAsmnt = isAllowed;
    this.SaveOvrAllAsmnt = isAllowed;
    this.UplEvdOvrAllReview = isAllowed;
    this.SaveOvrAllReview = isAllowed;
    this.SaveOvrAllAction = isAllowed;
    this.ActionrRequiredReview = isAllowed;
  }
}
